import React, { FunctionComponent, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { getFeedDetails } from 'Redux/selectors/feed'
import { getRejectReasons } from 'Redux/selectors/reviews'
import { FeedDetails } from 'Types/index'
import { SelectPlaylistProps, RejectReason } from './props'
import {
  Select,
  SelectOption,
  SelectOptionPercents,
  SelectOptionPlaylist,
  SelectOptionPlaylistTitle,
  SelectOptionPlaylistScoreLabel,
  SelectOptionPlaylistScore,
  SelectOptionPlaylistCover,
  SelectOptionPlaylistInfo,
  RejectOption,
  RejectOptionLabel,
} from './styles'

const SelectPlaylistComponent: FunctionComponent<SelectPlaylistProps> = ({
  ref,
  noReject,
  onChange,
  value,
}) => {
  const { t } = useTranslation()

  const reviewDetails: FeedDetails = useSelector(getFeedDetails)
  const rejectReasons: Array<RejectReason> = useSelector(getRejectReasons)

  const reviewPlaylistsOptions = useMemo(
    () =>
      reviewDetails.matched_playlists?.map(playlist => ({
        value: {
          id: playlist.id,
          type: 'add',
        },
        label: (
          <SelectOption>
            <SelectOptionPlaylist>
              <SelectOptionPlaylistCover src={playlist.playlist_cover} />
              <SelectOptionPlaylistInfo>
                <SelectOptionPlaylistTitle>
                  {playlist.playlist_name}
                </SelectOptionPlaylistTitle>
                <SelectOptionPlaylistScore>
                  <SelectOptionPlaylistScoreLabel>
                    {t('reviewsPage.score')}:
                  </SelectOptionPlaylistScoreLabel>
                  {playlist.score}
                </SelectOptionPlaylistScore>
              </SelectOptionPlaylistInfo>
            </SelectOptionPlaylist>
            <SelectOptionPercents percent={playlist.matched_percent}>
              {playlist.matched_percent}% {t('reviewsPage.match')}
            </SelectOptionPercents>
          </SelectOption>
        ),
      })),
    [reviewDetails]
  )

  const reviewRejectOptions = useMemo(
    () =>
      rejectReasons.map(reason => ({
        value: {
          id: reason[0],
          type: 'reject',
        },
        label: (
          <RejectOption>
            <RejectOptionLabel>{reason[1]}</RejectOptionLabel>
          </RejectOption>
        ),
      })),
    [rejectReasons]
  )

  return (
    <Select
      ref={ref}
      fill
      isSearchable={false}
      options={
        noReject
          ? reviewPlaylistsOptions
          : [...reviewPlaylistsOptions, ...reviewRejectOptions]
      }
      placeholder={t('reviewsPage.selectPlaceholder')}
      classNamePrefix="select-playlist"
      value={reviewPlaylistsOptions?.find(c => c.value?.id === value?.id)}
      // @ts-ignore
      onChange={val => onChange(val.value)}
    />
  )
}

export const SelectPlaylist = React.memo(SelectPlaylistComponent)
